import FacetList from "./FacetList";

export default FacetList;
